interface InstructionsProps {
  className?: string;
  type?: 'baseline' | 'savings';
}

export const Instructions = ({ className, type = 'baseline' }: InstructionsProps) => {
  return (
    <div className={className}>
      <h3>How to complete:</h3>
      <ul>
        <li>
          Work with your lab members to determine an average total for each
          column category in areas your lab has direct control over.
        </li>
        <li>
          Focus on estimates rather than exact numbers – the aim is to capture a
          realistic baseline, not perfect precision.
        </li>
        <li>After you finish hit Submit at the bottom right.</li>
      </ul>

      {type === 'baseline' && (
        <ul>
          <li>
            Tip: Be honest with your data. The more realistic you are about your
            current status, the easier it is to spot where improvements can make
            the biggest environmental impact.
          </li>
        </ul>
      )}

      {type === 'savings' && (
        <ul>
          <li>
            These rows describe the same equipment as entered in your baseline
            assessment.
          </li>
        </ul>
      )}
    </div>
  );
};
